module.exports = __webpack_public_path__ + "img/cloud1.5db9852.png";